import { lazyLoad } from 'utils/loadable';

export const OktaLoginPage = lazyLoad(
  () => import('app/components/pages/OktaLoginPage/index'),
  (module) => module.OktaLoginPage,
);
